module.exports = __webpack_public_path__ + "static/media/grey_star.9ab13106.svg";